import {Bm} from '../../../../graphql/generated/types';

/**
 * 기다무(기다무, 복합BM) 에 해당하는지 확인
 */
export function isWaitfreeBm(bm: Bm) {
  return [Bm.PayWaitfree, Bm.MixedWaitfree].includes(bm);
}
